import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, Divider, CardMedia } from '@material-ui/core/';
import PostDetailsStyles from '../../Styles/PostDetailsStyles';
import config from '../../Config/config';

class ResultPostDetails extends React.Component {
	constructor() {
		super();
		this.state = {
		};
	}

	render() {
		const { classes } = this.props;
		const { post } = this.props;
		const cost = (post.cost ? post.cost : post.impressions * config.PRICE / 1000).toFixed(2);
		const url = post.post.shortcode ? `https://www.instagram.com/p/${post.post.shortcode}/` : `https://www.instagram.com/${post.post.username}/`;

		return (
			< div >
				<Card className={classes.card}>
					<img alt="Instagram logo" className={classes.logo} src='https://storage.googleapis.com/vimma/ig_logo_40px.png' />
					<a href={url} target='_blank' rel="noopener noreferrer">
						<CardMedia
							className={classes.media}
							image={post.post.thumbnail_src}
							title="Instagram Post"
						/>
					</a>
					<CardContent>
						<Typography gutterBottom variant="body1">
							Cost: £{cost}
						</Typography>
						<Typography gutterBottom variant="body1">
							Impressions: {post.impressions > 1100 ? `${(post.impressions / 1000).toFixed(1)}K` : post.impressions}
						</Typography>
						<Typography gutterBottom variant="body1">
							Engagement: {post.engagement > 1100 ? `${(post.engagement / 1000).toFixed(1)}K` : (post.engagement ? post.engagement : '0')}
						</Typography>
						{(post.clicksFromProfile || post.clicksFromProfile === 0) && (
							<div>
								<Typography gutterBottom variant="body1">
									Link clicks: {post.clicksFromProfile > 1100 ? `${(post.clicksFromProfile / 1000).toFixed(1)}K` : post.clicksFromProfile}
								</Typography>
								<Typography gutterBottom variant="body1">
									CPC: {post.clicksFromProfile > 0 ? `£${(cost / post.clicksFromProfile).toFixed(2)}` : 'N/A'}
								</Typography>
							</div>
						)}
					</CardContent>
					<Divider />
				</Card>
			</div >
		);
	}
}

ResultPostDetails.propTypes = {
	classes: PropTypes.object.isRequired
};

ResultPostDetails.contextType = Context;

export default withStyles(PostDetailsStyles)(ResultPostDetails);
